import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../shared/components/modal/modal';
import { useAppDispatch } from '../../../../store/hooks';
import LazyModal, { LazyModalComponentProps } from '../../../ui/components/lazy-modal';
import { closeModal, setAlert } from '../../../ui/store/ui-slice';
import { useDisableUserTotpMutation, useGetUserQuery } from '../../api/user-api';
import { currentUserAlertId, totpModalDisableId } from '../../constants/constants';

const DisableTotp = ({ isOpen, afterClose }: LazyModalComponentProps): JSX.Element => {
  const { data: currentUser } = useGetUserQuery();
  const dispatch = useAppDispatch();
  const { t } = useTranslation('current-user');
  const [disableTotp, { isLoading }] = useDisableUserTotpMutation();

  const closeTotpModal = () => {
    dispatch(closeModal(totpModalDisableId));
  };

  const handleDisableTotp = () => {
    if (!currentUser?.id) {
      return;
    }
    disableTotp()
      .unwrap()
      .then(() => {
        closeTotpModal();
        dispatch(
          setAlert({
            id: currentUserAlertId,
            type: 'success',
            title: t('totp.message.disabled'),
          }),
        );
      });
  };

  return (
    <Modal
      title={t('totp.disableTotpTitle')}
      isOpen={isOpen}
      isLoading={isLoading}
      afterClose={afterClose}
      onOk={handleDisableTotp}
      onCancel={() => !isLoading && closeTotpModal()}
    >
      <Card>{t('totp.disableTotpText')}</Card>
    </Modal>
  );
};

const DisableTotpModal = (): JSX.Element => {
  return <LazyModal modalId={totpModalDisableId} Component={DisableTotp} />;
};

export default DisableTotpModal;
